import styled from 'styled-components';
import { UptimeModal, UptimeTypography } from '@uptime/uptime-component';
import DefaultUptimeTheme from 'utils/lumosTheme';
/**
 * Wraps profile name and menu chevron.
 */
export const LogoutModalWrapper = styled(UptimeModal)`
  border-radius: 12px;
  position: absolute;
  background-color: white;
  width: 543px;
  min-height: 205px;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);

  .gUDgpY {
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
  }
`;

export const ContentDescription = styled(UptimeTypography)`
  padding-top: ${({ theme }: { theme: typeof DefaultUptimeTheme }) => theme.space[2]}px;
  text-align: center;
`;
